import { render } from "./PlanGroupEdit.vue?vue&type=template&id=1276e220&scoped=true"
import script from "./PlanGroupEdit.vue?vue&type=script&lang=js"
export * from "./PlanGroupEdit.vue?vue&type=script&lang=js"

import "./PlanGroupEdit.vue?vue&type=style&index=0&id=1276e220&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1276e220"]])

export default __exports__